import { Button, Stack, Typography } from '@mui/material'

import { useRouter, useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'
import { encodeSkuId } from '@/core/sku'

import { Header } from './Header'

type BuyNowCompletionProps = {
  itemId?: string
  skuId?: string
  onClose: () => void
}

export const BuyNowCompletion: Organism<BuyNowCompletionProps> = ({
  itemId,
  skuId,
  onClose,
}) => {
  const { t } = useTranslation('storeItemDetail')
  const { router, generatePath, routerPages } = useRouter()
  return (
    <OrganismFrame>
      <Header title={t('completionTitle', '購入完了')} onClose={onClose} />
      <Stack alignItems="center" sx={{ pt: 6, pb: 5 }} spacing={2}>
        <Typography variant="h5">
          {t('orderCompleted', 'ご注文が完了しました。')}
        </Typography>
        <Typography variant="body2">
          {t('thankForYourPurchase', 'ご購入いただきありがとうございます！')}
        </Typography>
      </Stack>
      <Stack alignItems="center" sx={{ py: 5 }} spacing={4}>
        <Button
          size="large"
          sx={{ width: 244 }}
          onClick={() => {
            onClose()
            setTimeout(() => {
              router.push({
                pathname: generatePath(routerPages.OwnedItemDetail, {
                  itemId,
                }),
                search: skuId ? `?skuId=${encodeSkuId(skuId ?? '')}` : '',
              })
            })
          }}
        >
          {t('checkPurchasedItem', '購入した商品を確認する')}
        </Button>
        <Button
          size="large"
          variant="text"
          onClick={() => {
            onClose()
            setTimeout(() => {
              router.push(generatePath(routerPages.Top))
            })
          }}
        >
          {t('goToTOP', 'TOPページへ')}
        </Button>
      </Stack>
    </OrganismFrame>
  )
}
